import React, { useState } from 'react'
import clsx from 'clsx'
import icon from '@/assets/icons/mdi_sort-ascending.svg'
import { SortComponentProps } from '@/components/organisms/VideoLibrarySection/types'

export function SortComponent({ options, sortBy, sortFn }: SortComponentProps) {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = (option: string) => {
    sortFn(option)
    setIsOpen(!isOpen)
  }
  return (
    <div
      className="w-full tablet:w-auto text-left relative p-12 bg-primary-100 rounded-md cursor-pointer netbook:w-auto mb-16"
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="tablet:w-208 flex justify-between items-center text-text-dark-900 font-bold">
        <img src={icon} alt="" className="mr-8 netbook:mr-0" />
        {sortBy}
        <i
          className={clsx(isOpen && '-rotate-180', 'fa fa-chevron-down ml-auto netbook:ml-8 duration-300')}
          aria-hidden="true"
        />
      </div>
      {isOpen && (
        <div className="absolute top-full right-0 mt-8 z-30 bg-white p-12 w-full tablet:w-192 shadow-xl rounded-xl flex flex-col gap-24">
          {options &&
            options.map((option) => (
              <button
                type="button"
                onClick={() => handleClick(option)}
                className="w-full text-left cursor-pointer p-12 rounded-md hover:text-white hover:font-bold hover:bg-primary-500"
              >
                <span>{option}</span>
              </button>
            ))}
        </div>
      )}
    </div>
  )
}
